import styled, { css } from 'styled-components';
import { ifNotProp, switchProp } from 'styled-tools';
import { media } from '@prisjakt/ui-base';
import { colors } from '@prisjakt/ui-base/styles/variables';

export const VARIANTS = {
  DEFAULT: 'DEFAULT',
  CAMPAIGN: 'CAMPAIGN',
  HEADING: 'HEADING',
  SOTY: 'SOTY', // (Store of the Year)
  PRICE_LIST: 'PRICE_LIST',
};

export const variantToWidth = {
  [VARIANTS.DEFAULT]: 88,
  [VARIANTS.CAMPAIGN]: 88,
  [VARIANTS.HEADING]: 100,
  [VARIANTS.SOTY]: 176,
  [VARIANTS.PRICE_LIST]: 88,
};

const defaultNoLogoCss = css`
  min-width: 88px;
  max-width: 120px;
  min-height: 31px;
  max-height: 40px;
  font-size: 12px;
  line-height: 1.3em;
  word-break: break-word;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const priceListNoLogoCss = css`
  ${defaultNoLogoCss}
  max-width: 88px;
  text-align: center;
`;

const campaignNoLogoCss = css`
  font-size: 10px;
  color: ${colors.darkBlue2};
  width: 88px;
  max-width: 100%;
  height: 31px;
  line-height: 31px;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  border: 1px solid ${colors.lightGray1};
  ${media.mediumUp`
    font-size: 12px;
  `};
`;

const sotyNoLogoCss = css`
  color: ${colors.lightBlue3};
  text-decoration: underline;
`;

export const StoreLogo = styled.div`
  ${ifNotProp(
    'showLogo',
    switchProp('variant', {
      [VARIANTS.DEFAULT]: defaultNoLogoCss,
      [VARIANTS.HEADING]: defaultNoLogoCss,
      [VARIANTS.PRICE_LIST]: priceListNoLogoCss,
      [VARIANTS.CAMPAIGN]: campaignNoLogoCss,
      [VARIANTS.SOTY]: sotyNoLogoCss,
    })
  )};
`;

export const StoreLogoText = styled.span`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
